import React, { useEffect, useState } from "react";
import { Box, Typography, Container, Breadcrumbs, Grid } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Link, useParams } from "react-router-dom";

import { LikedHeading } from "../../components/heading";
import ToastMessage from "../../utils/ToastMessage";
import { getApiCall, getlikedProductApi } from "../../API/baseUrl";
import Loader from "../../components/loader";
import ButtonForAll from "../../components/ButtonForALL";
import ProductBox from "../../Componentsnew/productBox";
import { BreadcrumbsFunction } from "../../Componentsnew/Breadcrumbs/Index";
import emptyWishlist from "../../Assect/emptywishlist.png";
import TopPageImage from "../../components/toppageimage";

const Liked = () => {
  const user_id = localStorage.getItem("user_id");
  const [productList, setProductList] = useState([]);
  const [pending, setPending] = useState(false);
  const { liked } = useParams();

  const getLiked = async () => {
    setPending(true);
    try {
      const result = await getApiCall(`${getlikedProductApi}/${user_id}`);
      if (result?.data?.status) {
        setProductList(result?.data?.productDetails);
      } else {
        ToastMessage("error", result.data.message);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    getLiked();
  }, []);

  const updateApiCall = async () => {
    try {
      const result = await getApiCall(`${getlikedProductApi}/${user_id}`);
      if (result?.data?.status) {
        setProductList(result?.data?.productDetails);
      } else {
        ToastMessage("error", result.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <Box className="TopPageForMobile">
        {/* <TopPageImage pagename="Wishlist.." /> */}
      </Box>

      {pending ? (
        <Loader />
      ) : (
        <Box
          sx={{
            width: "100%",
            minHeight: "100vh",
            backgroundColor: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
            pt: 4,
            pb: 6,
          }}
        >
          {productList.length ? (
            <Container maxWidth="lg">
              <Typography
                variant="h5"
                sx={{ fontWeight: 600, mb: 2 }}
                className="wishlist_heading"
              >
                {LikedHeading}
              </Typography>

              <Box sx={{ mb: 2 }}>
                <Breadcrumbs
                  separator={<NavigateNextIcon fontSize="small" />}
                  aria-label="breadcrumb"
                >
                  <BreadcrumbsFunction link1="Home" page="Wishlist" />
                </Breadcrumbs>
              </Box>

              <Box className="wishList_img" sx={{ p: { xs: 1, md: 2 } }}>
                <ProductBox
                  renderproduct={productList}
                  setProductList={setProductList}
                  productApifunc={updateApiCall}
                />
              </Box>
            </Container>
          ) : (
            <div
              className="emptycon"
              style={{
                height: "70vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div className="data">
                <h3>No Wishlist Items Found</h3>
                <div
                  className="btnWishlist"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Link to={"/product"} style={{ textDecoration: "none" }}>
                    <ButtonForAll
                      name="CONTINUE SHOPING"
                      className="Wishlistbtn"
                    ></ButtonForAll>
                  </Link>
                </div>
              </div>
            </div>
          )}
        </Box>
      )}
    </>
  );
};

export default Liked;
